// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_0d624b9a27--checkbox--E83MD","box":"_0d624b9a27--box--TSmoe","invalid":"_0d624b9a27--invalid--duKFV","disabled":"_0d624b9a27--disabled--WW5p9"};